import { render, staticRenderFns } from "./ownerContract-changed-log.vue?vue&type=template&id=953313ae&scoped=true"
import script from "./ownerContract-changed-log.vue?vue&type=script&lang=js"
export * from "./ownerContract-changed-log.vue?vue&type=script&lang=js"
import style0 from "./ownerContract-changed-log.vue?vue&type=style&index=0&id=953313ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953313ae",
  null
  
)

export default component.exports